import { METHODS } from './../constants';
import utils from '../utils';
import { encryptString } from '../../utils/encrypt';

interface LoginData {
  customerId: string;
  password: string;
}

interface LoginOptions {
  data: LoginData;
}

const login = () => ({
  loginNetBanking: (data: LoginOptions) =>
    utils.fetch(`${process.env.HOST}/api/nb-login`, { ...data, method: METHODS.POST }),
  loginMpin: (data: LoginOptions) =>
    utils.fetch(`${process.env.HOST}/api/mpin-login`, { ...data, method: METHODS.POST }),
  loginMfIpUrl: () => `${process.env.HOST}/api/mf-lp-token`,
  loginPfmV2Url: (data: any) => 
    utils.fetch(`${process.env.HOST}/api/v2-login`, { data: { customerId: encryptString(data.customerId), channelId: encryptString(data.channelId) }, method: METHODS.POST  }) ,
  silentLoginIb: (token: string) =>
    utils.fetch(`${process.env.HOST}/api/ib-login`, { data: { encryptedToken: token }, method: METHODS.POST }),
  silentLoginMb: (token: string) =>
    utils.fetch(`${process.env.HOST}/api/mb-login`, { data: { encryptedToken: token }, method: METHODS.POST }),
  silentLoginPFMV2: (token: string) => 
    utils.fetch(`${process.env.HOST}/api/mutual-fund-sso-login`, { data: { encryptedToken: token }, method: METHODS.POST }),
  silentLoginCommon: (token: string) =>
    utils.fetch(`${process.env.HOST}/api/mb-login`, { data: { encryptedToken: token }, method: METHODS.POST }),
    silentLoginCIB: (token: string) =>
    utils.fetch(`${process.env.HOST}/api/cib-login`, { data: { encryptedToken: token }, method: METHODS.POST }),
  logout: () => utils.fetch(`${process.env.HOST}/api/logout`, { method: METHODS.POST }),
});

export default login;
